const XLINK_NS = 'http://www.w3.org/1999/xlink';
const SVG_NS = 'http://www.w3.org/2000/svg';

class InteractiveMap {
	constructor(block) {
		this.block = block;
		this.map = this.block.querySelector('svg');
		this.countryButtons = this.block.querySelectorAll('.block-interactive-map__col');

		const selected = this.block.dataset.selectedCountries;
		this.selectedCountries = selected ? JSON.parse(selected) : [];

		const urlsJson = this.block.dataset.countryUrls;
		this.countryUrls = urlsJson ? JSON.parse(urlsJson) : {};

		this.smallCountries = ['Mauritius', 'Rwanda', 'Sao-Tome', 'Seychelles','Maldives'];

		if (!this.map || !this.countryButtons.length) return;

		this.wrapMapPathsWithLinks();
		this.bindEvents();
		this.highlightSelectedCountries();
	}

	/**
	 * Wrap each selected country's SVG path in an <a> so the map links to the same destination as the list.
	 */
	wrapMapPathsWithLinks() {
		Object.keys(this.countryUrls).forEach((countryId) => {
			const url = this.countryUrls[countryId];
			if (!url) return;

			const path = this.map.querySelector(`#${CSS.escape(countryId)}`);
			if (!path || path.closest('a')) return;

			const link = document.createElementNS(SVG_NS, 'a');
			link.setAttributeNS(XLINK_NS, 'href', url);
			link.setAttribute('class', 'block-interactive-map__country-link');

			path.parentNode.insertBefore(link, path);
			link.appendChild(path);
		});
	}

	bindEvents() {
		this.countryButtons.forEach((button) => {
			const countryId = button.dataset.countryId;
			button.addEventListener('mouseenter', () => this.highlightCountryHover(countryId, true));
			button.addEventListener('mouseleave', () => this.highlightCountryHover(countryId, false));
		});

		this.map.querySelectorAll('[id]').forEach((path) => {
			path.addEventListener('mouseenter', () => this.highlightCountryHover(path.id, true));
			path.addEventListener('mouseleave', () => this.highlightCountryHover(path.id, false));
		});
	}

	highlightCountryHover(countryId, isHovering) {
		if (!this.selectedCountries.includes(countryId)) return;

		const svgCountry = this.map.querySelector(`#${countryId}`);
		const button = this.block.querySelector(`[data-country-id="${countryId}"]`);
		if (this.smallCountries.includes(countryId)) {
			this.toggleCircle(countryId, isHovering);
			if (button) button.classList.toggle('is-hovered', isHovering);
			return;
		}

		if (svgCountry) svgCountry.classList.toggle('is-hovered', isHovering);
		if (button) button.classList.toggle('is-hovered', isHovering);
	}

	highlightSelectedCountries() {
		this.countryButtons.forEach((button) => {
			const countryId = button.dataset.countryId;
			const svgCountry = this.map.querySelector(`#${countryId}`);
			if (svgCountry) svgCountry.classList.add('is-active');
		});
	}

	toggleCircle(countryId, show) {
		let circle = this.map.querySelector(`.circle-${countryId}`);

		if (show) {
			if (!circle) {
				const countryPath = this.map.querySelector(`#${countryId}`);
				if (!countryPath) return;

				const bbox = countryPath.getBBox();
				const cx = bbox.x + bbox.width / 2;
				const cy = bbox.y + bbox.height / 2;

				const remInPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
				const svgRect = this.map.getBoundingClientRect();
				const scaleX = this.map.viewBox.baseVal.width / svgRect.width;
				const scaleY = this.map.viewBox.baseVal.height / svgRect.height;
				const svgRadius = 1.5 * remInPx * Math.max(scaleX, scaleY);

				circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
				circle.classList.add(`circle-${countryId}`);
				circle.setAttribute('cx', cx);
				circle.setAttribute('cy', cy);
				circle.setAttribute('r', svgRadius);
				circle.setAttribute('fill', 'none');
				circle.setAttribute('stroke', '#BB494B');
				circle.setAttribute('stroke-width', '3');
				this.map.appendChild(circle);
			}
		} else if (circle) {
			circle.remove();
		}
	}
}

export default InteractiveMap;
